/** Tipos de remitente alineados con ITenantEmailSettingsService (API). */
export const CORREO_TIPOS_DOCUMENTO = [
  { value: 'FACTURAS', label: 'Facturas de venta' },
  { value: 'OP', label: 'Órdenes de pago' },
  { value: 'ECOMMERCE', label: 'Tienda Store' },
] as const;

export type CorreoTipoDocumento = (typeof CORREO_TIPOS_DOCUMENTO)[number]['value'];

export const labelCorreoTipoDocumento = (tipo: string) =>
  CORREO_TIPOS_DOCUMENTO.find((t) => t.value === tipo)?.label ?? tipo;
